import { isNil } from 'ramda'
import { getOrDefault } from 'libs/PagingParser'

const getFullName = (defaultValue) => (apiItem) => {
  if (isNil(apiItem.firstName)) return defaultValue
  if (isNil(apiItem.lastName)) return defaultValue
  return getOrDefault(defaultValue)(
    () => `${apiItem.firstName} ${apiItem.lastName}`,
  )
}

export const itemMapper = (apiItem) => {
  return {
    id: apiItem.id,
    avatar: apiItem.avatar,
    avatarCharacters: apiItem.avatarCharacters,
    name: getFullName(undefined)(apiItem),
    firstName: apiItem.firstName,
    lastName: apiItem.lastName,
    crmInfo: apiItem.crmInfo,
  }
}

//{data:{apiItem}, meta:{...}}
export const groupItemMapper = (apiItem) => {
  return {
    id: apiItem.id,
    title: apiItem.name,
    subtitle: apiItem.subscribersCount,
    tags: apiItem.tags,
    avatar: '',
  }
}
